import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    "& #page-title": {
      fontSize: "24px",
      marginBottom: "0px",
    },
  },
  topPanel: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  viewContainer: {
    marginTop: "20px",
  },
  dateSelector: {
    display: "flex",
    alignItems: "center",
    margin: "0px 15px",
    "& #date-selector-label": {
      fontSize: "15px",
      marginRight: "15px",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },

  icons: {
    float: "right",
    "& > *": {
      margin: theme.spacing(1),
    },
    height: 25,
  },
  iconButtonLabel: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: ".75rem",
    fontWeight: 400,
    lineHeight: 1,
  },
  formControl: {
    width: "100%",
    paddingLeft: 10,
  },
  dialog: {
    position: "absolute",
    scroll: "none",
    top: 0,
  },
  menuBar: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "15px",
    fontWeight: "bold",
    padding: "10px",
    backgroundColor: "#202124",
    color: "white",
    "& .MuiSvgIcon-root": {
      marginLeft: "5px",
      "&:hover": {
        backgroundColor: "#585858",
        color: "white",
      },
    },
  },
}));

export const useTableStyles = makeStyles({
  transactionPanel: {
    display: "flex",
    flexDirection: "column",
    fontSize: "18px",
    padding: "20px",
    marginBottom: "80px",
    borderTop: "none",
    "& h1": {
      fontSize: "19px",
      textDecoration: "underline",
      paddingBottom: "15px",
      margin: 0,
      display: "flex",
      justifyContent: "space-between",
      "& .MuiSvgIcon-root": {
        color: "#3f51b5",
        transition: "0.15s all linear",
        "&:hover": {
          transform: "scale(1.05)",
        },
      },
    },
    "& .MuiTableCell-root": {
      padding: "5px",
    },
    "& .MuiTableRow-root": {
      "&:hover": { backgroundColor: "lemonchiffon" },
    },
  },
  tableHeaderRow: {
    backgroundColor: "#333",
    "& .MuiTableCell-root": {
      fontSize: "15px",
      color: "white",
      backgroundColor: "#333",
      whiteSpace: "pre",
    },
  },
  dialog: {
    "& .MuiPaper-root": {
      borderRadius: "10px",
      border: "none",
    },
  },
  status: {
    display: "flex",
    justifyContent: "space-between",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& #status-label:hover": {
      textDecoration: "underline",
    },
  },
  sentButton: {
    color: "purple",
  },
});
